import React from 'react';
import { Link } from 'react-router-dom';
import aiRestaurantImage from '../assets/main_logo.png'; // Add your AI restaurant image path here

const HomePage = () => {
    return (
        <div className="p-8 text-center">
            {/* Welcome Section */}
            <h1 className="text-5xl font-bold text-gray-800">Welcome to NinjaBakers</h1>
            <p className="text-lg mt-4 text-gray-600">
                AI-powered restaurant and bakery solutions to optimize your business, reduce waste, and streamline orders.
            </p>


            {/* AI Image Section */}
            <div className="mt-8">
                <img
                    src={aiRestaurantImage}
                    alt="AI Powered Restaurant and Bakery"
                    className="w-full h-auto rounded-lg shadow-md"
                />
            </div>

            {/* Why NinjaBakers Section */}
            <section className="mt-8 bg-gray-100 p-6 rounded-lg shadow-md">
                <h2 className="text-2xl font-semibold text-gray-800">Why Choose NinjaBakers?</h2>
                <p className="text-lg text-gray-700 mt-2">
                    NinjaBakers uses AI-driven insights to help bakeries and restaurants boost profitability and improve operational efficiency.
                </p>
                <ul className="mt-4 text-left max-w-2xl mx-auto text-gray-700">
                    <li className="flex items-center"><span className="text-green-500 mr-2">✔</span> AI-Powered Predictions to minimize food wastage, saving at least $30,000 per month.</li>
                    <li className="flex items-center"><span className="text-green-500 mr-2">✔</span> Smart Inventory Management via Sensors to track food, bakery items, and raw materials in real-time.</li>
                    <li className="flex items-center"><span className="text-green-500 mr-2">✔</span> Fast & Reliable Delivery Coordination with real-time tracking.</li>
                    <li className="flex items-center"><span className="text-green-500 mr-2">✔</span> Virtual AI-Powered Assistant for Customized Cake Design, tailored to customer requirements.</li>
                    <li className="flex items-center"><span className="text-green-500 mr-2">✔</span> Smart Order Management for seamless tracking and reduced human errors.</li>
                    <li className="flex items-center"><span className="text-green-500 mr-2">✔</span> Automated Receipt Handling to prevent missed orders.</li>
                </ul>
            </section>

            {/* How It Works Section */}
            <section className="mt-8 p-6 rounded-lg shadow-md bg-white">
                <h2 className="text-2xl font-semibold text-gray-800">How It Works</h2>
                <div className="grid md:grid-cols-3 gap-6 mt-6">
                    <div className="p-4 bg-blue-100 rounded-lg">
                        <h3 className="text-xl font-bold text-blue-800">Step 1: Place an Order</h3>
                        <p className="text-gray-700 mt-2">Easily place orders through our AI-powered system, ensuring no order gets missed.</p>
                    </div>
                    <div className="p-4 bg-blue-100 rounded-lg">
                        <h3 className="text-xl font-bold text-blue-800">Step 2: AI Optimization & Management</h3>
                        <p className="text-gray-700 mt-2">Our AI optimizes inventory using smart sensors, predicts demand, and minimizes wastage.</p>
                    </div>
                    <div className="p-4 bg-blue-100 rounded-lg">
                        <h3 className="text-xl font-bold text-blue-800">Step 3: Virtual AI Assistant & Fast Delivery</h3>
                        <p className="text-gray-700 mt-2">Design custom cakes with our virtual assistant and get real-time delivery tracking.</p>
                    </div>
                </div>
            </section>

            {/* Call-to-Action Button */}
            <div className="mt-6">
                <Link to="/products" className="bg-blue-500 text-white px-6 py-3 rounded-md text-lg hover:bg-blue-600">
                    Explore Products
                </Link>
            </div>
        </div>
    );
};

export default HomePage;
